import * as Api from '@ViewModels';
import { provider, providerTag } from './helpers';

export const donorPerfectConfig = provider(Api.IntegrationProvider.DonorPerfect, {
	displayName: 'DonorPerfect',
	showConnections: false,

	configuration: {
		showOAuthClientCredentials: false,
		// One account-level API key, so there is no user whose credentials the sync would run as. Consequence to know
		// before turning this back on: the cleanup scheduler and the monthly full extract both skip an integration
		// whose SyncUserId is null, so DonorPerfect gets neither until something else assigns one.
		showSyncUser: false,
	},

	main: {
		writebacks: {
			// settingsKey is the contract with DonorPerfectIntegrationSettings.ActivityCodes, read by type name.
			grid: {
				optionsFrom: 'availableActivityCodes',
				settingsKey: 'activityCodes',
				placeholder: 'Choose an activity code',
				emptyOptionsLabel: 'No activity codes yet — run a full extract',
				// DonorPerfect accepts an activity with no code, so an unmapped type costs the coding, not the write-back.
				missingCodeHint: 'Written back without an activity code',
			},
		},
	},

	// The key facter emits the donor id and nothing else, and no DonorPerfect code path reads BirthdayDisplay, so
	// the section would offer a setting that changes nothing.
	showKeyFacts: false,

	tags: {
		coreTags: true,
		providerTags: [providerTag('DonorType', 'Donor Type'), providerTag('MajorDonor', 'Major Donor')],
	},
});
